@use "foundation/_colors.scss";

a.sso-button {
  display: flex;
  color: white;
  font-size: 1.125em;
  font-weight: 700;
  padding: 1em .5em;
  text-align: center;
  width: 100%;

  + .sso-button {
    margin-top: 1em;
  }
}

.sso-button-facebook {
  background-color: #3B579D;
}

.sso-button-content {
  display: flex;
  align-items: center;
  margin: auto;
}
